exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".star-icon__star___v-65U {\n  width: calc(20% - 3px);\n  height: auto;\n  display: inline-block;\n  padding-right: 3px;\n  box-sizing: content-box;\n}\n", ""]);

// exports
exports.locals = {
	"star": "star-icon__star___v-65U"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./node_modules/stylus-loader!./src/components/shared/StarIcon/star-icon.styl
// module id = 716
// module chunks = 0